import { motion } from "framer-motion";
import { Overline } from "../Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, image }) => (
  <section data-testid="page-header" className="relative bg-sml-forest overflow-hidden pt-32 pb-16 lg:pt-40 lg:pb-24">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-sml-forest via-sml-forest/85 to-sml-forest/40" />
      </div>
    )}
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Overline light>{eyebrow}</Overline>
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-6 font-display font-medium text-white text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-4xl text-balance"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 text-white/75 text-lg leading-relaxed max-w-2xl"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
